import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ivclass from '../../Modules/IVClass';
const Title = (props) => {
    const { highlightedHeading, plainHeading, highlightedHeadingClass, titleClass, } = props;
    return (_jsxs("h2", { className: ivclass('iv-text-grey-85 dark:iv-text-grey-0', 'iv-text-center', 'sm:iv-m-heading-xs md:iv-m-heading-2xl lg:iv-m-heading-2xl xl:iv-m-heading-3xl', 'sm:iv-text-heading-xs md:iv-text-heading-2xl lg:iv-text-heading-2xl xl:iv-text-heading-3xl', 'iv-font-extrabold', titleClass), children: [plainHeading, _jsx("span", { className: highlightedHeadingClass, children: highlightedHeading })] }));
};
export default Title;
